<div 
  [class]="'prime-petal-long ' + customClasses" 
  [ngStyle]="{
    'background-color': !group ? petalStyles?.secondary_color : 'transparent',
    'border' : !ifPrice && !group ? 'solid 0.4px' + petalStyles?.primary_color : 'none',
    'font-size': group ? '0' : '1.3rem'
  }"
  [ngClass]="{
    'prime-petal-long--detail': isDetail, 
    'prime-petal-long--cart': isCart,
    'prime-petal-long--suggest': group
  }"
>
  <ng-container *ngIf="ifPrice; else percentage">
    <div 
      *ngIf="isUnique" 
      class="prime-petal-long__percentage--unique"
      [ngStyle]="{
        'background-color': petalStyles?.primary_color,
        'color' : petalStyles?.secondary_color
      }"
      [ngClass]="{
        'prime-petal-long__percentage--unique-half': group && isHalf,
        'prime-petal-long__percentage--unique-full': group && !isHalf
      }"
    >
      <span class="prime-petal-long__text" [ngClass]="{'prime-petal-long__text--suggest': group}">{{primeOffer}}</span>
    </div>

    <span
      class="prime-petal-long__price" 
      [ngStyle]="{
        'color': petalStyles?.primary_dark_color
      }"
      [ngClass]="{'prime-petal-long__price--unique': isUnique}"
    >
      {{ value | multiCountryCurrency }}

      <span
        class="prime-petal-long__price--underline" 
        *ngIf="priceText > 0"
      >
        {{ priceText | multiCountryCurrency }}
      </span>
    </span>
  </ng-container>

  <ng-template #percentage>
    <div
      class="prime-petal-long__percentage"
      [ngClass]="{'prime-petal-long__percentage--suggest': group}"
      [ngStyle]="{
        'background-color': petalStyles?.primary_color,
        'color' : petalStyles?.secondary_color
      }"
    >
      <span class="prime-petal-long__text--from" *ngIf="group">Hasta</span>
      <span class="prime-petal-long__text" [ngClass]="{'prime-petal-long__text--suggest': group}">{{ value}}</span>
    </div>
  </ng-template>

  <img 
    class="mx-1 prime-petal-long__petal-image"
    [src]="petalImage"
    [routerLink]="['/prime']"
    [ngClass]="{
      'prime-petal-long__percentage-image-price': ifPrice,
      'prime-petal-long__percentage-img': !ifPrice,
      'prime-petal-long__petal-image--group-card': group && !isHalf && !primeTag,
      'prime-petal-long__petal-image--suggest-full': group && !isHalf && primeTag,
      'prime-petal-long__petal-image--unique': isUnique,
      'prime-petal-long__percentage-active': primeData?.active,
      'prime-petal-long__petal-image--suggest-half': group && isHalf
    }"
    alt="Farmatodo prime"
  />
  
  <img *ngIf="ifPrice && !isUnique && !group" src="assets/svg/arrow.svg" alt="Quiero ahorrar" class="prime-petal-long__row-img" />
</div>
